var md5 = require("md5");

const AUTH_USER = "authUser";

const TokenService = {
    getToken() {
        var authUserInfo = JSON.parse(localStorage.getItem(AUTH_USER));
        if (authUserInfo) {
            const loginDuration = authUserInfo.loginTime + authUserInfo.expireInSeconds;
            const currentTime = new Date().getTime() / 1000;
            const accessToken = authUserInfo.accessToken;

            if (accessToken && currentTime < loginDuration) {
                return accessToken;
            }
            else {
                this.removeToken();
                return "";
            }
        }
        else return "";
    },

    getAuthInfo() {
        return JSON.parse(localStorage.getItem(AUTH_USER));
    },

    saveToken(authUserResponse) {
        var authUser = {};
        authUser.accessToken = authUserResponse.accessToken;
        authUser.expireInSeconds = authUserResponse.expireInSeconds;
        authUser.encryptedAccessToken = authUserResponse.encryptedAccessToken;
        authUser.userId = authUserResponse.userId;
        authUser.loginTime = new Date().getTime() / 1000;

        localStorage.setItem(AUTH_USER, JSON.stringify(authUser));
    },

    removeToken() {
        localStorage.removeItem(AUTH_USER);
    },
};

export { TokenService };


// WEBPACK FOOTER //
// ./src/services/storage.service.js